export default {
  ...CONFIG.api,
};
